import { render } from "./ResetPasswordRequest.vue?vue&type=template&id=6537a8b0&scoped=true"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js"

import "./ResetPasswordRequest.vue?vue&type=style&index=0&id=6537a8b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6537a8b0"]])

export default __exports__